import { createFileRoute, Outlet } from "@tanstack/react-router"
import { useKbIndexEvents } from "@/api/queries/knowledge"
import { requireCap } from "@/lib/route-guards"

export const Route = createFileRoute("/_app/knowledge")({
  beforeLoad: requireCap("management"),
  component: KnowledgeLayout,
})

/** Every knowledge page shows index status: follow it live while in this section. */
function KnowledgeLayout() {
  useKbIndexEvents()
  return <Outlet />
}
